var fn = function( obj ){
var __t,__p='';
__p+='\n// post light setup\n// todo: should not be\n// specularColor += lSpecularColor * input.specularF0;';
return __p;
};
fn.toString=fn;
module.exports = fn;